export default {
  dayOfWeek () {
    return this.$dayOfWeek(this.schedule.date)
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/schedulings/components/transfer/resources/computed.js